export var dom = {
    disableElement: function (el) {
        if (!el)
            return;
        el.setAttribute('disabled', 'disabled');
        el.classList.add('opacity-50');
    },
    enableElement: function (el) {
        if (!el)
            return;
        el.removeAttribute('disabled');
        el.classList.remove('opacity-50');
    }
};
